import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconSavings } from '@redteclab/icons'

import { useGetExperiment } from '../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { StaticImage } from '../../../image'
import { productAccessorGetSellerPromotionFromOffer } from '../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { useProductPageContext } from '../productPageContext'
import { ProductSellerPromotionFlag } from '../ProductSellerPromotionFlag/ProductSellerPromotionFlag'

import ProductPageVolumePricingModalIcon from './ProductPageVolumePricingModalIcon.svg'

export const ProductPageVolumePricingModalNotification: FC = () => {
  const { currentOffer } = useProductPageContext()

  const sellerPromotion = currentOffer
    ? productAccessorGetSellerPromotionFromOffer(currentOffer)
    : undefined

  const isMarketplaceHarmonisationEnabled =
    useGetExperiment(EXPERIMENT_NAME_MARKETPLACE_HARMONISATION_PDP).variant !==
    EXPERIMENT_VARIATION.DEFAULT

  return (
    <div className="flex flex-row gap-2 rounded-xl bg-light-primary-low p-4">
      <span className="w-24">
        {isMarketplaceHarmonisationEnabled ? (
          <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-light-tertiary font-mono text-2xl font-medium">
            <IconSavings />
          </div>
        ) : (
          <StaticImage
            alt="volume pricing notification icon"
            src={ProductPageVolumePricingModalIcon}
          />
        )}
      </span>
      <div className="flex flex-col">
        {isMarketplaceHarmonisationEnabled && sellerPromotion ? (
          <h3 className="mb-1 text-s font-medium">
            <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
          </h3>
        ) : (
          <h3 className="mb-1 text-s font-medium text-dark-secondary">
            <FormattedMessage id="volumePricing.modal.notification.title" />
          </h3>
        )}
        <span className="text-s font-normal">
          <FormattedMessage id="volumePricing.modal.notification.content" />
        </span>
      </div>
    </div>
  )
}
